import type { LearnerResponse } from "@/resources/learner";
import { apiClient } from "./apiClient";

class LearnerService {
  async getById(id: string): Promise<LearnerResponse | null> {
    try {
      const response = await apiClient.get<LearnerResponse>(`/learners/${id}`);
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn("Learner API returned unexpected status:", response.status);
      return null;
    } catch (error) {
      console.error("Failed to fetch learner:", error);
      return null;
    }
  }

  async getByIds(ids: string[]): Promise<LearnerResponse[]> {
    try {
      const response = await apiClient.post<LearnerResponse[]>(
        `/learners/batch`,
        {
          ids,
        },
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn(
        "Learner batch API returned unexpected status:",
        response.status,
      );
      return [];
    } catch (error) {
      console.error("Failed to fetch learners batch:", error);
      return [];
    }
  }
}
export const learnerService = new LearnerService();
